import { useTableColumns } from '../../../../hooks/table/useTableColumns/useTableColumns';
import { useTableColumnWithFiltersAndSorters } from '../../../../hooks/useTableColumnWithFiltersAndSorters/useTableColumnWithFiltersAndSorters';
import { createPatientColumns } from '../../../patient/component/PatientsTableComponent/columns';
import { PatientsTableComponent } from '../../../patient/component/PatientsTableComponent/PatientsTableComponent';
import { PatientTableProps } from '../../type';

export interface MyAssignedPatientsTableComponentProps extends PatientTableProps {
}

export const MyAssignedPatientsTableComponent = ({
  totalSize,
  filters,
  sorters,
  ...props
}: MyAssignedPatientsTableComponentProps) => {
  const columns = useTableColumns(
    createPatientColumns,
    ['name', 'age', 'gender', 'program', 'vitals', 'controlLevel', 'RPMDays', 'billableTime', 'billable', 'clinic', 'provider', 'assignedRdHC', 'assignedCA', 'enrollmentDate'],
  );

  const columnsWithFilters = useTableColumnWithFiltersAndSorters({
    columns,
    filters,
    sorters: sorters || { columnKey: 'enrollmentDate', order: 'descend' },
    except: ['assignedRdHC', 'assignedCA'],
  });

  return (
    <PatientsTableComponent
      totalSize={totalSize}
      columns={columnsWithFilters}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};
